
<h1 mat-dialog-title>{{ 'SETTINGS.SHARE_PROJECT' | translate }}</h1>
<div style="font-size: 15px;font-weight: 600;">
  <mat-checkbox [(ngModel)]="shareAll" (change)="shareAllProjects($event)" class="mr-2">
   {{'GENERIC.SELECT_ALL' |  translate }}
  </mat-checkbox>
</div>
<mat-divider class="m-1"></mat-divider>
<div mat-dialog-content style="font-size: 14px">
  <div *ngFor="let g of data.projects">
    <mat-checkbox [checked]="data.user['projects'] && this.data.user['projects'].indexOf(g) !== -1" (change)="shareProject($event.checked,g)" class="mr-2">
      {{g.name}}
    </mat-checkbox>
    <mat-divider></mat-divider>
  </div>
</div>
<div mat-dialog-actions class="align-content-right">
  <button color="primary" mat-button (click)="ok()">{{ 'GENERIC.OK' | translate }}</button>
</div>
<div *ngIf="loading">
  <div class="loading">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
